import FooterLogo from "../../assets/images/FooterLogo.png";
import {
  FaFacebook,
  FaWhatsapp,
  FaPhone,
  FaEnvelope,
  FaMapMarkerAlt,
} from "react-icons/fa";
import { useTranslation } from "react-i18next";
import { SITE, SOCIAL_LINKS } from "../../constants/site";
import { isRtlLanguage } from "../../utils/i18n";
import "./LandingFooter.css";

const SOCIAL_ICONS = {
  facebook: FaFacebook,
  whatsapp: FaWhatsapp,
  phone: FaPhone,
};

const contactLinkClass =
  "caf-link-brand text-white/80 transition-colors break-words";

function ContactItem({ icon: Icon, children }) {
  return (
    <li className="flex items-start gap-2.5">
      <Icon className="mt-0.5 h-4 w-4 shrink-0 text-[var(--caf-green)]" />
      <span className="min-w-0 text-[13px] leading-5 text-white/80">{children}</span>
    </li>
  );
}

function OfficeCard({ title, children }) {
  return (
    <div className="landing-footer__office">
      <h3 className="caf-footer-heading mb-4 text-xs font-bold uppercase tracking-widest">
        {title}
      </h3>
      <ul className="space-y-3">{children}</ul>
    </div>
  );
}

function LandingFooter() {
  const { t, i18n } = useTranslation();
  const isRtl = isRtlLanguage(i18n.language);

  return (
    <footer dir={isRtl ? "rtl" : "ltr"} className="landing-footer">
      <div className="landing-footer__inner">
        <div className="landing-footer__top">
          <section className="landing-footer__brand">
            <img
              src={FooterLogo}
              alt={SITE.name}
              className="landing-footer__logo"
              loading="lazy"
              decoding="async"
            />
            <p className="landing-footer__intro">
              {t(
                "We are CAF Sports Company, one of the leading companies in Egypt and the United Arab Emirates specialized in the field of sports construction and industrial flooring",
              )}
            </p>
            <div className="landing-footer__socials">
              {SOCIAL_LINKS.map(({ id, href, external }) => {
                const Icon = SOCIAL_ICONS[id];
                return (
                  <a
                    key={id}
                    href={href}
                    target={external ? "_blank" : undefined}
                    rel={external ? "noopener noreferrer" : undefined}
                    aria-label={id}
                    className="landing-footer__social-link"
                  >
                    <Icon className="h-[18px] w-[18px]" />
                  </a>
                );
              })}
            </div>
          </section>

          <section className="landing-footer__contact">
            <h2 className="caf-footer-heading landing-footer__contact-title">
              {t("Reach Us")}
            </h2>
            <div className="landing-footer__offices">
            <OfficeCard title={t("General Inquiries")}>
              <ContactItem icon={FaEnvelope}>
                <a href={`mailto:${SITE.emails.info}`} className={contactLinkClass}>
                  {SITE.emails.info}
                </a>
              </ContactItem>
            </OfficeCard>

            <OfficeCard title={t("UAE Office")}>
              <ContactItem icon={FaEnvelope}>
                <a href={`mailto:${SITE.emails.uae}`} className={contactLinkClass}>
                  {SITE.emails.uae}
                </a>
              </ContactItem>
              <ContactItem icon={FaMapMarkerAlt}>
                <a
                  href={SITE.maps.uae}
                  target="_blank"
                  rel="noopener noreferrer"
                  className={contactLinkClass}
                >
                  {t("United Arab Emirates")}
                </a>
              </ContactItem>
              <ContactItem icon={FaPhone}>
                <a href={`tel:${SITE.phones.uae}`} className={contactLinkClass}>
                  (+971) 543575745
                </a>
              </ContactItem>
            </OfficeCard>

            <OfficeCard title={t("Egypt Office")}>
              <ContactItem icon={FaEnvelope}>
                <a href={`mailto:${SITE.emails.egypt}`} className={contactLinkClass}>
                  {SITE.emails.egypt}
                </a>
              </ContactItem>
              <ContactItem icon={FaMapMarkerAlt}>
                <a
                  href={SITE.maps.egypt}
                  target="_blank"
                  rel="noopener noreferrer"
                  className={contactLinkClass}
                >
                  {t("Medical Center 3, Nasr City, Egypt")}
                </a>
              </ContactItem>
              <ContactItem icon={FaPhone}>
                <div className="flex flex-col gap-1">
                  <a href={`tel:${SITE.phones.egyptPrimary}`} className={contactLinkClass}>
                    (+20) 1141227755
                  </a>
                  <a href={`tel:${SITE.phones.egyptSecondary}`} className={contactLinkClass}>
                    (+20) 12 648 4032
                  </a>
                </div>
              </ContactItem>
            </OfficeCard>
          </div>
        </section>
        </div>

        <div className="landing-footer__copyright">
          <a
            href={SITE.portfolioUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="landing-footer__copyright-link"
          >
            {t(
              "Copyright © 2024 All rights reserved | This Website is made by Eslam Emam",
            )}
          </a>
        </div>
      </div>
    </footer>
  );
}

export default LandingFooter;
